import React from 'react';
import { Link } from 'react-router-dom';
import FeaturedImage from './FeaturedImage';
import './FeaturedProductCard.css';

// Base64 encoded placeholder image
const PLACEHOLDER_IMAGE = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIwIiBoZWlnaHQ9IjIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjIwIiBoZWlnaHQ9IjIyMCIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjExMCIgeT0iMTIwIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTVweCIgZmlsbD0iIzk5OTk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSI+Tm8gSW1hZ2U8L3RleHQ+PC9zdmc+';

// Helper function for alt text
const getProductAlt = (product) => {
  return `${product.name} - ${product.shortDescription || 'Product from OriginSelect'}`;
};

// Format price with CAD and fixed decimals
const formatPrice = (price) => {
  return `CAD $${Number(price).toFixed(2)}`;
};

const FeaturedProductCard = ({ product, countryCode, handleProductClick, index }) => {
  // Determine if we should display the price (hide if -1, 0, undefined, or null)
  const shouldDisplayPrice = product.price !== -1 && product.price !== 0 && product.price !== undefined && product.price !== null && product.price > 0;
  
  // Check if this is a skeleton placeholder
  const isSkeletonPlaceholder = product.isSkeletonPlaceholder || !product.imageUrl;
  
  return (
    <div 
      className={`featured-product-card ${isSkeletonPlaceholder ? 'skeleton-placeholder' : ''}`}
      onClick={() => !isSkeletonPlaceholder && handleProductClick(product._id)}
      tabIndex={isSkeletonPlaceholder ? -1 : 0}
      role={isSkeletonPlaceholder ? "presentation" : "button"}
      aria-label={isSkeletonPlaceholder ? "Loading product..." : `View details for ${product.name}`}
      onKeyDown={(e) => {
        if (!isSkeletonPlaceholder && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          handleProductClick(product._id);
        }
      }}
    >
      <div className="featured-product-image-container">
        {isSkeletonPlaceholder ? (
          <div className="skeleton-image-placeholder">
            <div className="skeleton-shimmer"></div>
          </div>
        ) : (
          <FeaturedImage
            src={product.imageUrl || product.imagePath || PLACEHOLDER_IMAGE}
            alt={getProductAlt(product)}
            className="featured-product-img"
            width="300"
            height="300"
            priority={true}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = PLACEHOLDER_IMAGE;
            }}
          />
        )}
      </div>
      
      <div className="featured-product-info">
        {isSkeletonPlaceholder ? (
          <>
            <div className="skeleton-text skeleton-title"></div>
            <div className="skeleton-text skeleton-price"></div>
            <div className="skeleton-button"></div>
          </>
        ) : (
          <>
            <h3 className="featured-product-name">{product.name}</h3>
            
            {shouldDisplayPrice && (
              <p className="featured-product-price">
                {formatPrice(product.price)}
              </p>
            )}
            
            <Link
              to={`/country/${countryCode}/products/${product._id}`}
              className="featured-product-button"
              onClick={(e) => e.stopPropagation()}
            >
              View Product
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default FeaturedProductCard;